import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsContent } from '@/features/settings/components/integrations/IntegrationsContent';

export const Route = createFileRoute('/_dashboard/settings/integrations')({
  component: IntegrationsContent,
});
